import { Flex, Text } from '@chakra-ui/react';
import { SOCIAL_PLATFORMS } from 'ui-components/dist/platforms';
import Tooltip from '~/components/Tooltip';
import { INSTAGRAM_CONTENT_TYPES } from '~/constants';
import { formatAbbr } from '~/utils';
import { convertPxToRems } from '~/utils-ts';

import { NOT_APPLICABLE } from '../SearchContentTable.constants';
import { ColumnHelperMethodType } from '../SearchContentTable.types';
import { TextCell } from '../components/TextCell';

export const ColumnImpressions: ColumnHelperMethodType = (columnHelper) =>
  columnHelper.accessor((row) => row.contentId, {
    id: 'impressions',
    cell: ({ row }) => {
      const isReel =
        row.original.platform === SOCIAL_PLATFORMS.instagram &&
        row.original.channel === INSTAGRAM_CONTENT_TYPES.reels;

      return isReel ? (
        <Flex alignContent="center" justifyContent="center">
          <Tooltip
            label="Impressions is not available for Reels from the Instagram API"
            isTouchFriendly={false}
            fontSize="md"
            placement="bottom"
          >
            <Text
              as="span"
              color="primary.400"
              fontSize="sm"
              fontWeight="400"
              lineHeight={convertPxToRems(14)}
            >
              --
            </Text>
          </Tooltip>
        </Flex>
      ) : (
        <TextCell>
          {formatAbbr(row.original.impressions, NOT_APPLICABLE)}
        </TextCell>
      );
    },
  });
